import { pumpThreadModel } from '@models/pump-comments.model';
import { useModel } from 'foca';
import { isEqual, throttle } from 'lodash-es';
import { useEffect, useState } from 'react';
import { useRefreshFlag } from './use-refresh';

const fetchThreadList = throttle(pumpThreadModel.fetchThreadList, 10, {
  leading: true,
  trailing: false,
});
export const usePumpThreadList = (tokenAddress: string, page: number) => {
  const [_, setPre] = useState<{ tokenAddress: string; page: number }>();
  const [loading, setLading] = useState(false);

  const { refresh } = useRefreshFlag();
  const threadList = useModel(pumpThreadModel, (state) => state.comments[tokenAddress]);

  const getComments = async () => {
    const data = { tokenAddress, page };
    setPre((pre) => {
      if (!isEqual(pre, data)) {
        setLading(true);
      }
      return pre;
    });

    if (tokenAddress) {
      await fetchThreadList(tokenAddress, page);
    }
    setPre(data);
    setLading(false);
  };

  useEffect(() => {
    getComments();
  }, [page, refresh, tokenAddress]);

  return { loading, threadList };
};
